import Vue from 'vue'
import router from './router'
import store from './store'
import NProgress from 'nprogress' // progress bar
import 'nprogress/nprogress.css' // progress bar style
// import { getToken } from '@/utils/auth' // get token from cookie
import getPageTitle from '@/utils/get-page-title'
import Api from '@/api/api'
import { wxSetTitle } from '@/utils'

NProgress.configure({ showSpinner: false }) // NProgress Configuration

const whiteList = ['/login', '/auth-redirect'] // no redirect whitelist

router.beforeEach(async(to, from, next) => {
  // start progress bar
  NProgress.start()

  // set page title
  document.title = getPageTitle(to.meta.title)
  // wxSetTitle(to.meta.title)

  // localStorage.setItem('WxUserOpenIDNew', 'omCevvvtHG3PRBIbhJhKpOdo3UCs')
  // xcf的测试号wxb069e2ceb2582504
  // Vue.ls.set('WxUserOpenIDNew', 'omCevvvtHG3PRBIbhJhKpOdo3UCs', 1 * 24 * 60 * 60 * 1000)
  // Vue.ls.set('WxUserOpenIDNew', 'olRE3wt7R7t42gs9mlfW22OduFAk', 1 * 24 * 60 * 60 * 1000)

  if (!Vue.ls.get('WxUserOpenIDNew')) {
    const params = decodeURIComponent(window.location.href).split('?')[1]
    let code = params ? params.split('&')[0].split('=')[1] : '' // 截取url上的code ,可能没有,则返回''空字符串
    if (params ? params.split('&')[0].split('=')[0] !== 'code' : true) {
      code = ''
    }
    if (code) {
      // 返回用户信息
      Api.wechatLogin({code: code}).then((res) => { // 获取用户信息
        if (res.success) {
          // Vue.ls.set('WxUserOpenIDNew', res.result.openid, 1 * 24 * 60 * 60 * 1000)
          Vue.ls.set('WxUserOpenIDNew', res.result.openid)
          next()
        }
      })
    } else {
      let redirectUrl = window.location.href
      // 去掉 URL 末尾的斜杠（如果有的话）
      // if (redirectUrl.endsWith('/')) {
      //   redirectUrl = redirectUrl.slice(0, -1)
      // }
      redirectUrl = encodeURIComponent(redirectUrl)
      console.log('redirectUrl: ', redirectUrl)
      code = true
      // wxe59fd31b815adcf5 // 测试  wxceb0a68e930c4ad1 //正式
      // xcf的测试 wxb069e2ceb2582504
      window.location.href = 'https://open.weixin.qq.com/connect/oauth2/authorize?appid=wxceb0a68e930c4ad1&redirect_uri=' + redirectUrl + '&response_type=code&scope=snsapi_userinfo&state=123&connect_redirect=1#wechat_redirect'
      next()
    }
  } else {
    next()
  }
})

router.afterEach(() => {
  // finish progress bar
  NProgress.done()
})



// WEBPACK FOOTER //
// ./src/permission.js